// 应用范例详情

import { useState, useEffect } from 'react'
import fun from './../../common/common_fun'
import url from './../../common/url_config'
import { Spin, Button, Tag, Drawer, Table, Select, DatePicker, message, Modal, Switch, Popover } from 'antd'
import 'moment/locale/zh-cn';
import { LoadingOutlined, TeamOutlined, UnorderedListOutlined, MenuOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import Menu from '../../components/menu/menu_case'
import product from '../../img/product.png'
import cookie from 'react-cookies'
import common_data from './../../common/common_data'
import huijv from './../../common/huijv'

function App(props: any) {
  let [loading, set_loading] = useState(false)//加载中
  let [data, set_data] = useState([])//产品列表数据
  let [data_type_obj, set_data_type_obj] = useState({})//栏目属性
  let [draw_visible, set_draw_visible] = useState(false)//抽屉展示
  let [menu_show, set_menu_show] = useState('')//菜单是否展示
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文
  let [current_height, set_current_height] = useState(document.documentElement.clientHeight)//当前页面高度

  const get_data = (id: any) => {
    set_loading(true)
    fun['post_data'](url + 'get_user_case_by_type', { url_id: id, 'page_type': '应用范例', '是否显示': '显示' }).then(res => {
      if (res.status) {
        let rows = res.result.rows
        console.log('查询多条数据', rows)
        if (rows.length > 0) {
          set_data_type_obj(rows[0])
          set_menu_show(rows[0]['栏目中文名称'])
        } else {
          set_menu_show('合作伙伴产品应用范例')
        }
        let children_by_type: any = []//案例分类
        let children_by_type_en: any = []//案例分类英文
        let children_by_type_set: any = []//将案例分类后的use-case
        for (let i in rows) {
          if (children_by_type.indexOf(rows[i]['案例分类']) === -1) {
            children_by_type.push(rows[i]['案例分类'])
            children_by_type_en.push(rows[i]['案例分类英文'])
          }
        }

        for (let i in children_by_type) {
          let children: any = []
          for (let j in rows) {
            if (rows[j]['案例分类'] === children_by_type[i]) {
              children.push(rows[j])
            }
          }
          children_by_type_set.push({ name_ch: children_by_type[i], name_en: children_by_type_en[i], children })
        }

        set_data(children_by_type_set.map((item: any) => ({
          ...item,
          show_all: true,
        })))

        let url = window.location.href
        if (url.indexOf('#') > -1) {
          setTimeout(() => {
            window.location.href = url
          }, 300)
        }
      } else {
        message.error(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })
  }

  useEffect(() => {
    console.log(props.match.params.id)
    get_data(props.match.params.id)

    window.addEventListener('resize', (e: any) => {
      set_current_height(document.body.clientHeight)
    })
  }, [])

  return <div style={{ minHeight: current_height - 210 }}>
    {/* 左侧菜单 */}
    {!common_data.isMobile ? <div style={{ width: 320, float: 'left' }}><Spin spinning={loading}>
      {menu_show && <Menu current_page_type={menu_show} />}
    </Spin></div> : <><div style={{ textAlign: 'right' }}><Button icon={<UnorderedListOutlined />} onClick={() => set_draw_visible(true)}>{current_language_ch ? '菜单' : 'MENU'}</Button></div><Drawer title={'MENU'} width={250} onClose={() => set_draw_visible(false)} visible={draw_visible}><Menu /></Drawer></>}

    <div style={{
      width: common_data.isMobile ? '100%' : 'calc(100% - 320px)',
      float: 'right',
    }} >
      <Spin spinning={loading}>
        <div style={{ width: '100%', margin: '0 auto', }}>
          <div style={{ width: '98%', margin: '0 auto', }}>
            <div className='overview_big_title' style={{ textAlign: 'left', fontWeight: 'bold', color: '#0e4e81' }}>
              <span style={{ fontFamily: 'PoppinsBold', fontSize: 30 }}>{current_language_ch ? data_type_obj['栏目中文名称'] : data_type_obj['栏目英文名称']}</span>
            </div>
            <div style={{ fontSize: 15, lineHeight: '20px', marginBottom: 15 }}>{current_language_ch ? data_type_obj['栏目中文描述'] : data_type_obj['栏目英文描述']}</div>
            {(data.length === 0 && !loading) && <div style={{ textAlign: 'center', lineHeight: '40px' }}>{current_language_ch ? '暂无数据' : 'No Data'}</div>}
          </div>

          {/* 主数据 */}
          {data.map((item_0: any, index_0: number) => <div style={{ backgroundColor: index_0 % 2 === 1 ? '#f7f5f1' : '#ffffff' }} key={index_0}>
            <div style={{ width: '98%', margin: '0 auto', }}>
              <div style={{ fontFamily: 'PoppinsBold', fontSize: 24, color: '#0e4e81', paddingTop: 20, fontWeight: 'bold', paddingBottom: 20 }}>
                {current_language_ch ? item_0.name_ch : item_0.name_en}
                <span onClick={() => {
                  let temp: any = [...data]
                  temp[index_0]['show_all'] = !temp[index_0]['show_all']
                  set_data(temp)
                }} style={{
                  fontFamily: 'PoppinsBold', color: '#215bd6', cursor: 'pointer', fontSize: 15, marginLeft: 10,
                }}>{current_language_ch ? (!item_0.show_all ? '展开' : '收起') : (!item_0.show_all ? 'More' : 'Less')} {!item_0.show_all ? <DownOutlined /> : <UpOutlined />}</span>
              </div>

              {item_0.show_all && <>
                {item_0.children.map((item: any, index: number) => <div style={{ marginTop: 10, paddingBottom: 10 }} id={item.url_id} key={index}>
                  <div style={{ fontFamily: 'PoppinsBold', marginBottom: 0, fontWeight: 'bold', fontSize: 18 }}>
                    {current_language_ch ? item['标题中文'] : item['标题英文']}</div>
                  {item.href_url ? <div>
                    {/* 有静态html情况 */}
                    <a style={{ color: '#215bd6' }} target={'_blank'} href={'/article/' + item.href_url + (current_language_ch ? '' : '-en')} dangerouslySetInnerHTML={{ __html: current_language_ch ? item['描述中文'] : item['描述英文'] }}></a>
                    {/* 无静态html情况，显示详情 */}
                  </div> : <div style={{}} dangerouslySetInnerHTML={{ __html: current_language_ch ? item['内容中文'] : item['内容英文'] }}></div>}
                </div>)}
              </>}
            </div>
          </div>)}
        </div>
      </Spin>
    </div>
  </div>
}

export default App;